import { Flex, Switch } from 'antd';
import { useAtom } from 'jotai';
import React from 'react';
import { spellcheckDisabledWithCookieAtom } from '~/atoms';
import ExpandableContent from '~/components/shared/ExpandableContent/ExpandableContent';

function SpellcheckSettings() {
  const [isDisabled, setIsDisabled] = useAtom(spellcheckDisabledWithCookieAtom);

  return (
    <ExpandableContent title='Correcteur orthographique' titleClassName='body1' withArrow>
      <Flex vertical gap={16} className='py-l'>
        <p className='body1'>Le correcteur orthographique vérifie automatiquement vos textes lors de la rédaction des annonces et messages.</p>
        <Flex gap={8}>
          <Switch checked={!isDisabled} onChange={() => setIsDisabled(!isDisabled)} />
          <p className='body1'>Activer le correcteur orthographique</p>
        </Flex>
      </Flex>
    </ExpandableContent>
  );
}

export default SpellcheckSettings;
